import React from 'react'
import { Helmet } from 'react-helmet'

function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page inconnue</title>
        <meta name='robots' content='noindex' />
      </Helmet>

      <div className='error'>
        <h1>404</h1>
        <p>Oups, cette page n&apos;hexiste pas</p>
      </div>
    </>
  )
}

export default NotFound
